export default __webpack_public_path__ + "static/media/signup.7d14d852.jpg";